import { render, staticRenderFns } from "./SuggestLegalCasesStep.vue?vue&type=template&id=81169d4a&"
import script from "./SuggestLegalCasesStep.vue?vue&type=script&lang=js&"
export * from "./SuggestLegalCasesStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports